import apiClient from '@/services/AccountClient'

export default {
  fetchCampaign (campaignId, options) {
    return apiClient.sendRequest(
      'GET',
      `api/admin/v1/referrals/${campaignId}`,
      undefined,
      options
    )
  },
  fetchAllCampaigns (options) {
    return apiClient.sendRequest(
      'GET',
      'api/admin/v1/referrals',
      undefined,
      options
    )
  },
  createCampaign (data, options) {
    return apiClient.sendRequest(
      'POST',
      'api/admin/v1/referrals',
      data,
      options
    )
  },
  updateCampaign (campaignId, data, options) {
    return apiClient.sendRequest(
      'PUT',
      `api/admin/v1/referrals/${campaignId}`,
      data,
      options
    )
  },
  deleteCampaign (campaignId, options) {
    return apiClient.sendRequest(
      'DELETE',
      `api/admin/v1/referrals/${campaignId}`,
      undefined,
      options
    )
  }
}
